import { Injectable } from '@angular/core';

import { Odds } from '@frontend/sports/odds/feature';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class QuickBetPickBoostedOddsProviderService {
    odds = new ReplaySubject<Odds>(1);
    boostedOdds$ = this.odds.asObservable();

    init(boostedOdds: Odds) {
        this.odds.next(boostedOdds);
    }
}
